module.exports = __webpack_public_path__ + "static/img/makehole3.69ad5713.png";